export const headerStyle = {
    padding: '15px 0'
}

export const logoStyle = {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '10vh'
}